<template>
  <div class="background_concept">
    <div class="concept_index_text">
      <p style="font-size: 24px;margin-bottom: 20px">Value</p>
      <p style="font-size: 24px;margin-bottom: 20px">SIG endeavors to find companies with</p>
      <p style="font-size: 24px;margin-bottom: 20px">unique value propositions.</p>
      <p style="font-size: 12px">e believe that a truly great business starts with a distinctive</p>
      <p style="font-size: 12px">business idea and stands out for its core values and beliefs.</p>
      <p style="font-size: 12px">We never stop looking for the companies that genuinely solve</p>
      <p style="font-size: 12px">problems and may change the world in the future.</p>
      <p style="font-size: 12px">When we find such a company, we stay in it for the long-run.</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>

    </div>

  </div>
</template>


<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Concept_index_en_m',
  components: {
    DownOutlined,

  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>


<style scoped>
.background_concept {
  background-image: url("../../../assets/background/concept_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.concept_index_text {
  padding-top: 40vh;
  text-align: center;
}

.index_down {
  padding-top: 2vh;
}
</style>